import { SERVICE_COLORS } from '@/helpers/constants'
import { DefaultColors } from '@/theme/defaults/colors'

export const LINK_STYLES = ['bracket', 'rail', 'curves', 'dim', 'none'] as const

export type LinkStyle = (typeof LINK_STYLES)[number]

export const DEFAULT_LINK_STYLE: LinkStyle = 'bracket'

// Note: the styles that draw in the overlay and so need the row positions measured
export const MEASURED_LINK_STYLES: LinkStyle[] = ['bracket', 'rail', 'curves']

export const parseLinkStyle = (value: unknown): LinkStyle =>
  LINK_STYLES.find((style) => style === value) ?? DEFAULT_LINK_STYLE

// Note: shared by the connector lines and the selected row's border so they match
export const LINK_STROKE_WIDTH = 1.5

// Note: '' is the default (the neutral gray the connectors always had)
export const DEFAULT_LINK_COLOR = ''

// Note: where the custom color picker starts when nothing custom is picked yet
export const DEFAULT_CUSTOM_COLOR = DefaultColors.blue500

// Note: how long the custom color picker has to stay still before the color is applied
export const CUSTOM_COLOR_APPLY_DELAY = 400

// Note: the project's own palettes - the brand tokens first, then the service / booking type swatches
export const LINK_COLORS = [
  ...new Set([
    DefaultColors.black700,
    DefaultColors.blue500,
    DefaultColors.purple500,
    DefaultColors.green500,
    DefaultColors.orange500,
    DefaultColors.red500,
    ...(SERVICE_COLORS as string[]),
  ]),
]

const HEX_COLOR = /^#[0-9a-f]{6}$/i

// Note: a palette color or any custom hex color; anything else falls back to the default
export const parseLinkColor = (value: unknown): string =>
  typeof value === 'string' && HEX_COLOR.test(value) ? value.toLowerCase() : DEFAULT_LINK_COLOR

// Note: set on the columns grid when a color is picked, read by the selected row
export const LINK_COLOR_VAR = '--linked-columns-color'

// Note: the column header row (the add button height); the lists start under it
export const COLUMN_HEADER_MIN_HEIGHT = '3.2rem'

// Note: a centered page is at most 1920px wide with 40px padding, so the margin right of the lists is
// only 40px until the screen passes 1920px. 2320px leaves room for the island (220px + 16px gap)
// on both sides; below it the view settings move to a menu in the page header
export const VIEW_SETTINGS_INLINE_MIN_WIDTH = 2320
